import { androidCaller, iosCaller } from './appInterface';

const ANDROID_OS = "ANDROID", IOS_OS = "IOS";

let app = {
    callFunction: () => { console.log("Não foi possível fazer a chamada do método, módulo não foi configurado corretamente durante inicialização.") }
};

const initEnvironment = (config) => {
    if (!config) {
        console.log("Config parameter needed");
        return;
    }

    if (config.platform.toUpperCase() == ANDROID_OS) {
        app = androidCaller;
    } else if (config.platform.toUpperCase() == IOS_OS) {
        app = iosCaller;
    }
};

export { app, initEnvironment };